
import loginComponent from '~/components/loginComponent.vue';
export default {
  components: { loginComponent },
};
